import React from "react";
import { Link } from "react-router-dom";

export default function ProductCard({ product }) {
  const { slug, name, brand, category, price, sale, tag, image, pod } = product;
  const soon = pod === false;
  return (
    <Link
      to={`/product/${slug}`}
      className="group block relative rounded-lg overflow-hidden bg-card border border-white/10 card-hover hover:border-neon/50"
    >
      <div className="relative aspect-[4/5] overflow-hidden bg-[#0e0e10]">
        <img
          src={image}
          alt={name}
          loading="lazy"
          className={`w-full h-full object-cover img-zoom ${soon ? "grayscale opacity-55" : ""}`}
        />

        {soon ? (
          <>
            <span className="absolute top-3 left-3 text-[10px] font-bold uppercase tracking-[0.14em] px-2 py-1 rounded bg-white/90 text-black">
              Coming Soon
            </span>
            <span className="absolute inset-x-0 bottom-0 flex justify-center pb-4">
              <span className="text-[11px] font-bold uppercase tracking-[0.2em] px-4 py-2 rounded-full bg-black/70 text-white border border-white/25 backdrop-blur-sm">
                Coming Soon
              </span>
            </span>
          </>
        ) : (
          <>
            {tag && (
              <span
                className={`absolute top-3 left-3 text-[10px] font-bold uppercase tracking-[0.14em] px-2 py-1 rounded ${
                  tag === "TRASH PILE"
                    ? "bg-trash text-white"
                    : tag === "HERO PIECE" || tag === "PREMIUM DROP" || tag === "POD DROP"
                    ? "bg-neon text-black"
                    : "bg-black/70 text-white border border-white/15"
                }`}
              >
                {tag}
              </span>
            )}
            {sale && (
              <span className="absolute top-3 right-3 text-[10px] font-bold uppercase tracking-wide px-2 py-1 rounded bg-white text-black">
                Sale
              </span>
            )}
          </>
        )}
      </div>
      <div className="p-4">
        <p className="text-[11px] uppercase tracking-[0.14em] text-white/45">{brand}</p>
        <h3 className="mt-1 font-semibold text-[15px] text-white leading-snug group-hover:text-neon transition-colors">
          {name}
        </h3>
        <div className="mt-2 flex items-center justify-between">
          <span className="flex items-center gap-1.5 text-[11px] uppercase tracking-[0.14em] text-white/45">
            {category}
            {!soon && <span className="text-neon/80 font-semibold">· POD</span>}
          </span>
          <span className="flex items-center gap-2">
            {soon ? (
              <span className="text-white/50 font-semibold text-sm">Soon</span>
            ) : sale ? (
              <>
                <span className="text-white/40 line-through text-sm">${price}</span>
                <span className="text-neon font-bold">${sale}</span>
              </>
            ) : (
              <span className="text-white font-bold">${price}</span>
            )}
          </span>
        </div>
      </div>
    </Link>
  );
}
